export function getBrowser() {
  var userAgent = navigator.userAgent;
  var browserName;

  if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
  } else if (userAgent.indexOf("SamsungBrowser") > -1) {
      browserName = "Samsung Internet";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
      browserName = "Opera";
  } else if (userAgent.indexOf("Trident") > -1) {
      browserName = "IE";
  } else if (userAgent.indexOf("Edge") > -1) {
      browserName = "Edge";
  } else if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
  } else {
      browserName = "Unknown";
  }

  return browserName;
}